export const CATEGORY_FILTER_OPTIONS = {
  ALL: 'All',
  NO_BIDS: 'Items With No Bids',
  ALL_BUY_IT_NOW: 'All Buy It Now Items',
  AVAILABLE_BUY_IT_NOW: 'Available Buy It Now Items',
}

export const hasNoBids = (item) => Number(item?.BidCount ?? 0) === 0

export const isAvailableBuyItNowItem = (item) => (
  item?.TotalItemsRemaining == null || Number(item.TotalItemsRemaining) !== 0
)

export const getFilteredAuctionItems = ({ bidItems = [], fixedItems = [], categoryFilter }) => {
  const activeFilter = categoryFilter || CATEGORY_FILTER_OPTIONS.ALL

  switch (activeFilter) {
    case CATEGORY_FILTER_OPTIONS.ALL:
      return {
        bidItems,
        fixedItems,
      }
    case CATEGORY_FILTER_OPTIONS.NO_BIDS:
      return {
        bidItems: bidItems.filter(hasNoBids),
        fixedItems: [],
      }
    case CATEGORY_FILTER_OPTIONS.ALL_BUY_IT_NOW:
      return {
        bidItems: [],
        fixedItems,
      }
    case CATEGORY_FILTER_OPTIONS.AVAILABLE_BUY_IT_NOW:
      return {
        bidItems: [],
        fixedItems: fixedItems.filter(isAvailableBuyItNowItem),
      }
    default:
      return {
        bidItems: bidItems.filter(item => item.Category === activeFilter),
        fixedItems: fixedItems.filter(item => item.Category === activeFilter),
      }
  }
}
